import { render, staticRenderFns } from "./icon-select.vue?vue&type=template&id=0dc2443a"
import script from "./icon-select.vue?vue&type=script&lang=js"
export * from "./icon-select.vue?vue&type=script&lang=js"
import style0 from "./icon-select.vue?vue&type=style&index=0&id=0dc2443a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports